import React,{useState, useEffect, useRef} from "react";
import PrimaryJobInterest from "@/data/PrimaryJobInterest";
import { useStepperContext } from "../StepperContext";
import {
options
} from "@/data/Technologies";
import { useDispatch, useSelector } from "react-redux";

import Select from 'react-select'

import { addJobLookFor, addPJobInt, addProffExp,addPJobExp,addPHourRate, addPMonthlySalary,addLinkedIn,addGitHub,addSkills, addExperienceError, addJobtypeError, addPriJobInterestError, addExperienceYearError, addHourlyrateError, addMonthlysalaryError, addLinkedinURLError, addGithubURLError} from "@/lib/redux/Features/freelancerSlice";
import { setMaxListeners } from "events";


function Details() {
  const { userData, setUserData } = useStepperContext();
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [jobtypeError,setJobtypeError]=useState("");
  const [experienceError,setExperienceErro]=useState("");
  const [primaryjobError,setPrimaryjobError]=useState("");
  const [experienceYearError,setExperienceYearError]=useState("");
  const [hourlyrateError,setHourlyrateError]=useState("");
  const [monthlySalaryError,setMonthlySalaryError]=useState("");
  const [linkedinURLError,setLinkedinURL]=useState("");
  const [githubURLError,setGithubURLError]=useState("");
  
  const dispatch=useDispatch();

  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
    if(name==='jobtype'){
        dispatch(addJobLookFor(value))
    }
    else if(name==='experienceYears'){
      dispatch(addProffExp(value))
    }
    else if(name==='primaryJobInterest'){
      dispatch(addPJobInt(value))
    }
    else if(name==='experienceYearsInPrimaryJobInterest'){
      dispatch(addPJobExp(value))
    }
    else if(name==='hourlyRate'){
      dispatch(addPHourRate(value))
    }
    else if(name==='monthlySalary'){
      dispatch(addPMonthlySalary(value))
    }
    else if(name==='linkedinURL'){
      dispatch(addLinkedIn(value))
    }
    else if(name==='githubURL'){
      dispatch(addGitHub(value))
    }



    
    if (name === "jobtype") {
      if (value.trim() === "") {
        setJobtypeError("Jobtype is required");
        dispatch(addJobtypeError("yes"));
      } else {
        setJobtypeError("");
        dispatch(addJobtypeError(null));
      }
    }

    if (name === "experienceYears") {
      if (value.trim() === "") {
        setExperienceErro("Experience is required");
        dispatch(addExperienceError("yes"));
      } else {
        setExperienceErro("");
        dispatch(addExperienceError(null));
      }
    }

    if (name === "primaryJobInterest") {
      if (value.trim() === "") {
        setPrimaryjobError("PrimaryJob Interest is required");
        dispatch(addPriJobInterestError("yes"));
      } else {
        setPrimaryjobError("");
        dispatch(addPriJobInterestError(null));
      }
    }

    if (name === "experienceYearsInPrimaryJobInterest") {
      if (value.trim() === "") {
        setExperienceYearError("Experience Year is required");
        dispatch(addExperienceYearError("yes"));
      } else {
        setExperienceYearError("");
        dispatch(addExperienceYearError(null));
      }
    }

    if (name === "hourlyRate") {
      if (value.trim() === "") {
        setHourlyrateError("Hourly rate is required");
        dispatch(addHourlyrateError("yes"));
      } else {
        setHourlyrateError("");
        dispatch(addHourlyrateError(null));
      }
    }

    if (name === "monthlySalary") {
      if (value.trim() === "") {
        setMonthlySalaryError("Monthly Salary rate is required");
        dispatch(addMonthlysalaryError("yes"));
      } else {
        setMonthlySalaryError("");
        dispatch(addMonthlysalaryError(null));
      }
    }

    if (name === "linkedinURL") {
      if (value.trim() === "") {
        setLinkedinURL("linkedin URL is required");
        dispatch(addLinkedinURLError("yes"));
      } else {
        setLinkedinURL("");
        dispatch(addLinkedinURLError(null));
      }
    }

    if (name === "githubURL") {
      if (value.trim() === "") {
        setGithubURLError("github URL is required");
        dispatch(addGithubURLError("yes"));
      } else {
        setGithubURLError("");
        dispatch(addGithubURLError(null));
      }
    }
  
  };


  const handleSkillsChange = (selectedOptions) => {
    setSelectedSkills(selectedOptions);
    setUserData({ ...userData, skills: selectedOptions });
    dispatch(addSkills(selectedOptions))
  };
  
  return (
    <div className="flex flex-col ">
      <div className="mx-2 w-full flex-1">
      <div className="mt-3 h-auto text-xs font-bold uppercase leading-8 text-gray-500 mb-3">
  What kind of job are you looking for?*
</div>

        <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
          <select
            onChange={handleChange}
            value={userData["jobtype"] || ""}
            name="jobtype"
            className="w-full appearance-none p-1 px-2 text-gray-800 outline-none">
              <option value="">Select Job Type</option>
            <option value="Part Time">Part Time (Up to 20 hours a week)</option>
            <option value="Full Time">Full Time (40 hours a week)</option>
            <option value="Any">Any</option>
          </select>
        </div>
        {jobtypeError && <span className="text-red-500">{jobtypeError}</span>}
      </div>
      <div className="mx-2 w-full flex-1">
      <div className="mt-3 h-auto text-xs font-bold uppercase leading-8 text-gray-500 mb-3">
  How many years of professional experience do you have?*
</div>

        <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
          <input
            onChange={handleChange}
            value={userData["experienceYears"] || ""}
            name="experienceYears"
            type="number"
            min={0}
            placeholder="Years of experience"
            className="w-full appearance-none p-1 px-2 text-gray-800 outline-none"
          />
        </div>
        {experienceError && <span className="text-red-500">{experienceError}</span>}
      </div>
      <div className="mx-2 w-full flex-1">
        <div className="mt-3 h-auto text-xs font-bold uppercase leading-8 text-gray-500 mb-3">
          Primary Job Interest*
        </div>
        <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
          <select
            onChange={handleChange}
            value={userData["primaryJobInterest"] || ""}
            name="primaryJobInterest"
            className="w-full appearance-none p-1 px-2 text-gray-800 outline-none">
            <option value="">Select Job</option>
            {PrimaryJobInterest.map((job, index) => (
              <option key={index} value={job}>
                {job}
              </option>
            ))}
          </select>
        </div>
        {primaryjobError && <span className="text-red-500">{primaryjobError}</span>}
      </div>
      <div className="mx-2 w-full flex-1">
      <div className="mt-3 h-auto text-xs font-bold uppercase leading-8 text-gray-500 mb-3">
  Years of experience in Primary Job Interest*
</div>

        <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
          <input
            onChange={handleChange}
            value={userData["experienceYearsInPrimaryJobInterest"] || ""}
            name="experienceYearsInPrimaryJobInterest"
            type="number"
            min={0}
            placeholder="Years of experience"
            className="w-full appearance-none p-1 px-2 text-gray-800 outline-none"
          />
        </div>
        { experienceYearError && <span className="text-red-500">{experienceYearError}</span>}
      </div>
        <div className="mx-2 flex-1 mt-2 items-end	">
        <div className="mt-3 h-auto text-xs font-bold uppercase leading-8 text-gray-500 mb-3">
    Skills*
  </div>
  <Select
        isMulti
        name="Skills"
        options={options}
        className="basic-multi-select"
        classNamePrefix="select"
        value={selectedSkills}
        onChange={handleSkillsChange}
      />
    
        </div>
      <div className="mx-2 w-full flex-1">
        <div className="mt-3 h-auto text-xs font-bold uppercase leading-8 text-gray-500 mb-3">
        Preferred Hourly Rate (in USD)*
        </div>
        <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
          <input
            onChange={handleChange}
            value={userData["hourlyRate"] || ""}
            name="hourlyRate"
            type="number"
            min={0}
            placeholder="Hourly Rate"
            className="w-full appearance-none p-1 px-2 text-gray-800 outline-none"
          />
        </div>
        {  hourlyrateError && <span className="text-red-500">{ hourlyrateError}</span>}
      </div>
      <div className="mx-2 w-full flex-1">
      <div className="mt-3 h-auto text-xs font-bold uppercase leading-8 text-gray-500 mb-3">
  Preferred Monthly Salary for long term jobs (in USD)*
</div>

        <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
          <input
            onChange={handleChange}
            value={userData["monthlySalary"] || ""}
            name="monthlySalary"
            type="number"
            min={0}
            placeholder="Monthly Salary"
            className="w-full appearance-none p-1 px-2 text-gray-800 outline-none"
          />
        </div>
        {  monthlySalaryError && <span className="text-red-500">{ monthlySalaryError}</span>}
      </div>
      <div className="mx-2 flex-1 ">
        <div className="mt-3 h-auto text-xs font-bold uppercase leading-8 text-gray-500 mb-3">
        Your linkedin profile URL
        </div>
        <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
          <input
            onChange={handleChange}
            value={userData["linkedinURL"] || ""}
            name="linkedinURL"
            placeholder="linkedin URL"
            className="w-full appearance-none p-1 px-2 text-gray-800 outline-none"
          />
        </div>
        {   linkedinURLError && <span className="text-red-500">{  linkedinURLError}</span>}
      </div>
      <div className="mx-2 flex-1 ">
        <div className="mt-3 h-auto text-xs font-bold uppercase leading-8 text-gray-500 mb-3">
        Your github profile URL
        </div>
        <div className="my-2 flex rounded border border-gray-200 bg-white p-1">
          <input
            onChange={handleChange}
            value={userData["githubURL"] || ""}
            name="githubURL"
            placeholder="github URL"
            className="w-full appearance-none p-1 px-2 text-gray-800 outline-none"
          />
        </div>
        {   githubURLError && <span className="text-red-500">{  githubURLError}</span>}
      </div>
      
    </div>
  );
}

export default Details;
